import { scenes } from "@/mocks/content";
import { Reveal, SectionHeading } from "./common";

export default function Scenes() {
  return (
    <section id="scenes" className="section-anchor w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="关键看点"
            title="六个值得回看的关键情节"
            desc="这些段落未必是最热闹的，却是信息量最集中的。它们用细节和沉默，替代了直白的台词，也支撑起了整个结局的氛围。"
          />
        </Reveal>

        <div className="mt-8 md:mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5">
          {scenes.map((scene, i) => (
            <Reveal key={scene.no} delay={i * 50}>
              <article className="h-full rounded-lg bg-background-50 border border-background-200 p-5 transition-colors hover:border-accent-300">
                <div className="flex items-center gap-3">
                  <span className="font-heading text-2xl md:text-3xl font-bold text-accent-500">
                    {scene.no}
                  </span>
                  <span className="flex-1 h-px bg-background-200"></span>
                  <i className="ri-film-line text-foreground-300 text-lg"></i>
                </div>
                <h3 className="mt-3 font-heading text-base md:text-lg font-semibold text-foreground-950">
                  {scene.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {scene.text}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}